"use client";

import { useLocale } from "@/lib/useLocale";
import { clsx } from "clsx";
import { t } from "@/lib/translations";

export function LangToggle({ className }: { className?: string }) {
  const { locale, setLocale } = useLocale();

  return (
    <div className={clsx("flex items-center gap-1 text-sm font-medium", className)}>
      <button
        type="button"
        onClick={() => setLocale("id")}
        className={clsx(
          "px-2 py-1 rounded transition-colors",
          locale === "id"
            ? "bg-brand-600 text-white"
            : "text-gray-500 hover:text-gray-700",
        )}
        title={t(locale, "lang.id")}
      >
        ID
      </button>
      <span className="text-gray-300">|</span>
      <button
        type="button"
        onClick={() => setLocale("en")}
        className={clsx(
          "px-2 py-1 rounded transition-colors",
          locale === "en"
            ? "bg-brand-600 text-white"
            : "text-gray-500 hover:text-gray-700",
        )}
        title={t(locale, "lang.en")}
      >
        EN
      </button>
    </div>
  );
}
